// FILE: src/pages/users/userService.js

import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const usersCollection = collection(db, "users");

// GET ALL USERS — filtered by company_id
export const getAllUsers = async () => {
  const user      = JSON.parse(localStorage.getItem("user") || "{}");
  const companyId = user?.company_id || "";

  if (!companyId) return [];

  const q        = query(usersCollection, where("company_id", "==", companyId));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docItem) => ({
    id: docItem.id,
    ...docItem.data()
  }));
};

// ADD USER — always attach company_id
export const addUser = async (userData) => {
  const user      = JSON.parse(localStorage.getItem("user") || "{}");
  const companyId = user?.company_id || "";
  if (!companyId) throw new Error("company_id is required");

  return await addDoc(usersCollection, {
    ...userData,
    company_id: companyId,  // ✅
    created_at: serverTimestamp(),
  });
};

// UPDATE USER
export const updateUser = async (id, updatedData) => {
  const user      = JSON.parse(localStorage.getItem("user") || "{}");
  const companyId = user?.company_id || "";
  if (!companyId) throw new Error("company_id is required");
  if (!id) throw new Error("user id is required");

  const userRef  = doc(db, "users", id);
  const snap     = await getDocs(query(usersCollection, where("company_id", "==", companyId)));
  const isOwned  = snap.docs.some((d) => d.id === id);
  if (!isOwned) {
    throw new Error("Access denied — user belongs to a different company");
  }

  // Never allow a generic update to reassign the tenant a user belongs
  // to — company_id must never be settable through this function.
  const { company_id: _ignored, ...safeData } = updatedData;

  return await updateDoc(userRef, safeData);
};